<app-admin-header></app-admin-header>

<div class="dashboard-container">
  <app-admin-sidebar></app-admin-sidebar>

  <div class="dashboard-main">
    <h2>📊 Dashboard</h2>

    <!-- 🆕 Highlighted Cards: Expiring Soon & Low Stock -->
    <div class="highlight-cards">
      <div class="highlight-card warning">
        ⚠️ Expiring Soon (≤ 3 months): <strong>{{ expiringSoon }}</strong>
      </div>
      <div class="highlight-card danger">
        🔻 Low Stock Items: <strong>{{ lowStock }}</strong>
      </div>
    </div>

    <!-- Existing stats -->
    <div class="stats">
      <div class="card">🧪 Total Drugs: <strong>{{ totalDrugs }}</strong></div>
      <div class="card">📦 Stock Items: <strong>{{ totalStockItems }}</strong></div>
      <div class="card">👥 Total Patients: <strong>{{ totalPatients }}</strong></div>
      <div class="card">🏥 In-Patients: <strong>{{ totalInPatients }}</strong></div>
      <div class="card">🚶 Out-Patients: <strong>{{ totalOutPatients }}</strong></div>
      <div class="card">🩺 Patients Issued: <strong>{{ totalPatientsIssued }}</strong></div>
      <div class="card">📤 Total Issues: <strong>{{ totalIssues }}</strong></div>
      <div class="card">💊 Quantity Issued: <strong>{{ totalQuantityIssued }}</strong></div>
      <div class="card">🏪 Stores: <strong>{{ totalStores }}</strong></div>
      <div class="card">🏥 Wards: <strong>{{ totalWards }}</strong></div>
    </div>

    <canvas id="summaryChart" width="400" height="180"></canvas>

    <div class="activities">
      <h3>🕒 Recent Activity</h3>
      <ul>
        <li *ngFor="let item of recentActivities">{{ item }}</li>
      </ul>
    </div>
  </div>
</div>
